import { SLOT_TRANSLATION_CHARACTER } from '@Core/Animation/SpineWrapperSlotManager';
import { Gamble, GAMBLER_TEXT_SLOTS } from '../Gamble';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import i18next from 'i18next';
import { Container } from 'pixi.js';

export class GambleText {
    //TODO: Migrate to PIXI
    public textContainer: Container;
    // public text: GameObjects.Text;
    // public slotName: GAMBLER_TEXT_SLOTS;
    constructor(gamble: Gamble, slotName: GAMBLER_TEXT_SLOTS) {
        // this.textContainer = gamble.scene.add.container(0, 0);
        // this.slotName = slotName;
        // const gambleConfig = gamble.gameStore.get(EGameStoreKeys.GambleConfiguration);
        // const hasTranslation = gamble.gambleSpine.slotManager.getAllTranslatableSlotNames()?.includes(slotName);
        // this.text = gamble.scene.add
        //     .text(0, 0, hasTranslation ? i18next.t(slotName.slice(SLOT_TRANSLATION_CHARACTER.length)) : '', {
        //         fontFamily: gambleConfig.gambleFont,
        //         fontSize: gambleConfig.gambleFontSize
        //     })
        //     .setOrigin(0.5);
        // this.textContainer.add(this.text);
        // gamble.gambleElements.add(this.textContainer);
        // gamble.gambleSpine.slotManager.assignObjectToSlot(slotName, this.text.parentContainer);
    }
}
